import {
  Targeting,
  SEC,
  HEX,
  SF_
} from "../../../src";
const spear_of_light = {
  slug: "spear_of_light",
  name: "Spear of Light",
  abilityIcon: "spear_of_light",
  costs: [
    { stat: "mana", value: 10 },
    { stat: "energy", value: 5 }
  ],
  targeting: Targeting.Beam,
  cooldown: SEC(3),
  windup: 24,
  // Instant effect after windup
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.LINE_3,
        // 3-hex line pattern (will be rotated to face target)
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                gold: {
                  type: "fated",
                  fixed: SF_(0.25),
                  rating: 1
                },
                physical: {
                  type: "chance",
                  min: SF_(0.04),
                  max: SF_(0.06),
                  rating: 1
                }
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "spell", "beam"]
};
export {
  spear_of_light
};
//# sourceMappingURL=data:application/json;base64,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
